import React from 'react';
import {Avatar, Card, CardContent, List, Sheet, Stack, Typography} from '@mui/joy';
import {SkillModel} from "../model/skill";
import {ServiceModel} from "../model/service";

function Service({service}: { service: ServiceModel }) {
    return (
        <Sheet variant='soft' sx={{padding: 2, borderRadius: 8, width: 220, height: 190}}>
            <Stack alignItems="center" spacing={1} justifyContent="center" direction="column">
                <Avatar variant='plain' size='lg' src={service.iconUrl}/>
                <CardContent>
                    <Typography textAlign="center" fontSize='lg' style={{wordWrap: "normal"}} level="title-lg">{service.title}</Typography>
                    <CardContent>
                        <Typography p={1} textAlign="center" level="body-sm">{service.description}</Typography>
                        {/*<List sx={{
                            "--ListItem-paddingX": "0px",
                            "--ListDivider-gap": "0px",
                            "--List-gap": "0px",
                            justifyContent: "flex-start"
                        }}>
                            {service.services.map((item: string) => (
                                <Typography key={item} textAlign="center" level="body-md">{item} </Typography>
                            ))}
                        </List>
                        */}
                    </CardContent>
                </CardContent>
            </Stack>
        </Sheet>
    );
}

export default Service;